import { useEffect } from "react";
import { useParams, Link } from "react-router-dom";
import Breadcrumb from "@/components/feature/Breadcrumb";
import TrendingPanel from "@/components/feature/TrendingPanel";
import { ArticleRow } from "@/components/feature/ArticleCard";
import { articles, categories, getArticlesByCategory, getCategoryBySlug } from "@/mocks/news";

const siteUrl = "https://budingmh.com.cn";

export default function CategoryPage() {
  const { slug = "" } = useParams();
  const category = getCategoryBySlug(slug);
  const list = getArticlesByCategory(slug);
  const others = categories.filter((c) => c.slug !== slug);

  useEffect(() => {
    if (category) {
      document.title = `${category.name}爆料最新消息_每日爆料`;
      const desc = document.querySelector('meta[name="description"]');
      if (desc) {
        desc.setAttribute(
          "content",
          `${category.name}栏目提供每日爆料最新即时快讯与热点事件追踪，${category.desc}新鲜猛料第一时间更新。`
        );
      }
    }
  }, [category]);

  if (!category) {
    return (
      <div className="mx-auto max-w-7xl px-4 md:px-6 py-20 text-center">
        <div className="text-5xl text-background-300 mb-4"><i className="ri-error-warning-line"></i></div>
        <h1 className="font-heading text-xl font-bold text-foreground-900">未找到该栏目</h1>
        <p className="mt-2 text-foreground-500">你访问的栏目不存在或已下线。</p>
        <Link to="/" className="mt-5 inline-flex items-center gap-1 bg-primary-600 text-background-50 px-5 py-2.5 rounded-md hover:bg-primary-500">
          返回首页<i className="ri-arrow-right-line"></i>
        </Link>
      </div>
    );
  }

  const jsonLd = {
    "@context": "https://schema.org",
    "@graph": [
      {
        "@type": "CollectionPage",
        name: `${category.name}爆料栏目`,
        description: `${category.name}栏目每日最新爆料与即时快讯。`,
        url: `${siteUrl}/category/${category.slug}`,
        breadcrumb: { "@type": "BreadcrumbList", itemListElement: [
          { "@type": "ListItem", position: 1, name: "首页", item: siteUrl },
          { "@type": "ListItem", position: 2, name: `${category.name}爆料`, item: `${siteUrl}/category/${category.slug}` },
        ] },
        mainEntity: { "@type": "ItemList", itemListElement: list.map((a, i) => ({
          "@type": "ListItem", position: i + 1, name: a.title, url: `${siteUrl}/news/${a.id}`,
        })) },
      },
    ],
  };

  return (
    <>
      <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: JSON.stringify(jsonLd) }} />
      <div className="bg-gradient-to-b from-primary-50/70 to-background-50">
        <div className="mx-auto max-w-7xl px-4 md:px-6 pt-6 pb-8">
          <Breadcrumb items={[{ label: "首页", to: "/" }, { label: `${category.name}爆料` }]} />

          {/* 栏目头部 */}
          <div className="mt-5 relative rounded-xl overflow-hidden">
            <div className="relative h-44 md:h-56 w-full">
              <img
                src={category.cover}
                alt={`${category.name}栏目最新爆料封面`}
                title={`${category.name}爆料栏目 - 每日爆料`}
                className="w-full h-full object-cover object-top"
              />
              <div className="absolute inset-0 bg-gradient-to-r from-foreground-950/90 via-foreground-950/60 to-foreground-950/20"></div>
            </div>
            <div className="absolute left-0 top-0 h-full flex flex-col justify-center px-6 md:px-10 max-w-2xl">
              <h1 className="font-heading text-3xl md:text-4xl font-black text-background-50">{category.name}爆料</h1>
              <p className="mt-3 text-sm md:text-base text-background-200/90 leading-relaxed line-clamp-2 hidden md:block">{category.desc}</p>
              <div className="mt-4 flex items-center gap-4 text-xs text-background-200/80 flex-wrap">
                <span className="inline-flex items-center gap-1.5 bg-background-50/15 px-3 py-1 rounded-full">
                  <i className="ri-article-line"></i>已收录 {list.length || articles.filter((a) => a.category === category.slug).length} 条
                </span>
                <span className="inline-flex items-center gap-1.5 bg-background-50/15 px-3 py-1 rounded-full">
                  <i className="ri-flashlight-line text-accent-300"></i>实时更新
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* 列表主体 */}
      <div className="mx-auto max-w-7xl px-4 md:px-6 pb-6">
        <div className="grid grid-cols-1 lg:grid-cols-3 gap-8">
          <div className="lg:col-span-2">
            {list.length === 0 ? (
              <div className="bg-background-100 border border-background-200 rounded-xl p-10 text-center">
                <i className="ri-inbox-2-line text-4xl text-background-300"></i>
                <p className="mt-3 text-foreground-500">该栏目内容正在紧张筹备中，先看看其他栏目吧。</p>
              </div>
            ) : (
              <div className="grid grid-cols-1 sm:grid-cols-2 gap-x-8 gap-y-7">
                {list.map((a) => (
                  <div key={a.id} className="border-b border-background-100 pb-5">
                    <ArticleRow article={a} />
                  </div>
                ))}
              </div>
            )}

            {/* 其他栏目 */}
            <div className="mt-8 bg-background-100/70 border border-background-200 rounded-xl p-5">
              <h3 className="font-heading font-bold text-foreground-950 mb-3 text-sm">切换其他栏目</h3>
              <div className="flex items-center gap-2 flex-wrap">
                {others.map((c) => (
                  <Link
                    key={c.slug}
                    to={`/category/${c.slug}`}
                    className="inline-flex items-center gap-1.5 bg-background-50 border border-background-200 text-foreground-700 text-sm px-3.5 py-2 rounded-full hover:border-primary-400 hover:text-primary-700 transition-colors whitespace-nowrap"
                  >
                    <i className="ri-price-tag-3-line"></i>{c.name}爆料
                  </Link>
                ))}
              </div>
            </div>
          </div>

          {/* 侧栏 */}
          <TrendingPanel />
        </div>
      </div>
    </>
  );
}